import React, { useState } from "react";
import {
  EuiButton,
  EuiForm,
  EuiFormRow,
  EuiFieldText,
  EuiEmptyPrompt,
  EuiFieldPassword,
  EuiIcon,
} from "@elastic/eui";
import { useDispatch } from "react-redux";
import { loginWithEmailPass } from "../../features/auth/auth.thunk";
export const LoginPage = () => {
  const dispatch = useDispatch();
  const [email, setEmail] = useState("prabhuvilla@akhaj.com");
  const [password, setPassword] = useState("");

  const onChangeEmail = (e) => {
    setEmail(e.target.value);
  };
  const onChangePassword = (e) => {
    setPassword(e.target.value);
  };
  const loginCall = () => {
    dispatch(
      loginWithEmailPass({
        email,
        password,
      })
    );
  };
  const loginCallOnKeyPress = (e) => {
    if (e.key === "Enter") {
      loginCall();
    }
  };
  return (
    <EuiEmptyPrompt
      body={
        <EuiForm>
          <EuiFormRow label="Enter Email">
            <EuiFieldText
              style={{ padding: "3px" }}
              name="Email"
              type="email"
              onChange={(e) => onChangeEmail(e)}
              value={email}
              onKeyPress={loginCallOnKeyPress}
              prepend={
                <EuiIcon
                  type="email"
                  style={{ backgroundColor: "white", marginLeft: "5px" }}
                />
              }
            />
          </EuiFormRow>
          <EuiFormRow label="Enter Password">
            <EuiFieldPassword
              name="Password"
              type={"dual"}
              onChange={(e) => onChangePassword(e)}
              value={password}
              onKeyPress={loginCallOnKeyPress}
            />
          </EuiFormRow>
          <EuiFormRow label="">
            <EuiButton type="submit" onClick={loginCall} fill>
              Login
            </EuiButton>
          </EuiFormRow>
        </EuiForm>
      }
    ></EuiEmptyPrompt>
  );
};
